import { useTenant } from './useTenant';

export type { AppRole } from '@/providers/tenantContext';

export function useUserRole() {
  const { roles, isAdmin, isCSR, isAffiliate, isTech, isTechOnly, isLoadingMe, hasRole } = useTenant();

  return {
    roles,
    isAdmin,
    isCSR,
    isAffiliate,
    isTech,
    isTechOnly,
    isLoading: isLoadingMe,
    hasRole,
  };
}
